import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

import { ReportsService } from '../report';

export const dashboardState = {
   parent: 'app',
   name: 'dashboard',
   url: '/dashboard',
   data: {
      nav: {
         title: 'Dashboard',
         icon: 'e360-icon-dashboard'
      }
   },
   component: 'dashboard',
   resolve: {
      datasets: getDatasets
   }
};

getDatasets.$inject = ['ReportsService'];
function getDatasets(reportsService:ReportsService) {
   let ids = Object.freeze([
      'campaign-goal-prereg', 'campaign-goal-participant',
      'campaign-goal-contact-optin', 'campaign-goal-sales-lead',
      'participant-map', 'optin-funnel', 'email-total'
   ]);

   return reportsService.getDatasets(...ids);
}

ng.module('e360').config(configRoutes);

configRoutes.$inject = ['$stateRegistryProvider'];
function configRoutes($stateRegistry:uir.StateRegistry) {
   $stateRegistry.register(dashboardState);
}
